import { library, IconDefinition } from "@fortawesome/fontawesome-svg-core";
import {
    faBars,
    faSort,
    faSortDown,
    faSortUp,
    faCaretUp,
    faCaretDown,
    faEye,
    faEyeSlash,
    faTimes,
    faPencil,
    faTrash,
    faTrashRestore,
    faUser,
    faUsers,
    faSquareCheck,
    faDownload,
    faCheck,
    faCaretLeft,
    faCaretRight,
    faAnglesLeft,
    faAngleLeft,
    faArrowLeft,
    faAnglesRight,
    faAngleRight,
    faArrowRight,
    faArrowDown,
    faAdd,
    faMinus,
    faLocationDot,
    faPlus,
    faMagnifyingGlass,
    faCamera,
    faDog,
    faBriefcase,
    faMapPin,
    faBell,
    faEnvelope,
    faSprayCan,
    faSeedling,
    faScrewdriverWrench,
    faCalendarAlt,
    faClock,
    faBoxArchive
} from "@fortawesome/free-solid-svg-icons";

import { faUser as faUserRegular, faTrashCan, faFileLines, faCreditCard, faFolderOpen } from "@fortawesome/free-regular-svg-icons";

library.add(
    faBars as IconDefinition,
    faSort as IconDefinition,
    faSortDown as IconDefinition,
    faSortUp as IconDefinition,
    faCaretUp as IconDefinition,
    faCaretDown as IconDefinition,
    faEye as IconDefinition,
    faEyeSlash as IconDefinition,
    faTimes as IconDefinition,
    faPencil as IconDefinition,
    faTrash as IconDefinition,
    faTrashCan as IconDefinition,
    faTrashRestore as IconDefinition,
    faUser as IconDefinition,
    faUserRegular as IconDefinition,
    faUsers as IconDefinition,
    faSquareCheck as IconDefinition,
    faDownload as IconDefinition,
    faCheck as IconDefinition,
    faSquareCheck as IconDefinition,
    faCaretLeft as IconDefinition,
    faCaretRight as IconDefinition,
    faAnglesLeft as IconDefinition,
    faArrowLeft as IconDefinition,
    faAnglesRight as IconDefinition,
    faAngleLeft as IconDefinition,
    faAngleRight as IconDefinition,
    faArrowRight as IconDefinition,
    faArrowDown as IconDefinition,
    faAdd as IconDefinition,
    faMinus as IconDefinition,
    faLocationDot as IconDefinition,
    faPlus as IconDefinition,
    faMagnifyingGlass as IconDefinition,
    faCamera as IconDefinition,
    faDog as IconDefinition,
    faBriefcase as IconDefinition,
    faMapPin as IconDefinition,
    faBell as IconDefinition,
    faEnvelope as IconDefinition,
    faSprayCan as IconDefinition,
    faSeedling as IconDefinition,
    faScrewdriverWrench as IconDefinition,
    faCalendarAlt as IconDefinition,
    faFileLines as IconDefinition,
    faCreditCard as IconDefinition,
    faClock as IconDefinition,
    faFolderOpen as IconDefinition,
    faBoxArchive as IconDefinition
);
